<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalCertificado">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4><i class="fa fa-certificate"></i> Cadastrar Certificado A1</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group" :class="{'is-invalid':errors.has('Certificado')}">
                        <label class="label-required"> <required/> {{
                                $t('message.certificate_file')}}</label>
                        <input name="Certificado" ref="certificado" accept=".pfx" v-validate="{required:true}"
                            @change="previewCertificate" id="certificateFile" class="form-control" type="file">
                        <div class="invalid-feedback help-block error">{{errors.first('Certificado')}}</div>
                    </div>
                    <div class="form-group" :class="{'is-invalid':errors.has('Senha')}">
                        <label class="label-required" for="Senha"> <required/>
                            {{ $t('message.certificate_password')}}</label>
                        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                        <input class="form-control" v-validate="{required:true}" v-model="certificado.certificado_senha"
                            placeholder="Digite a senha do certificado" id="Senha" maxlength="25" name="Senha" value=""
                            type="password">
                        <div class="invalid-feedback help-block error">{{errors.first('Senha')}}</div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" @click="saveCertificate()" :disabled="loading"
                        class="btn btn-success float-right"><i class="fa fa-check"></i>
                        {{$t('words.save')}} <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                certificado: {
                    certificado_senha: '',
                    certificado_a1: '',
                    certificado_vencimento: '',
                },
            };
        },
        methods: {
            saveCertificate() {
                this.$validator
                    .validateAll([
                        'Certificado',
                        'Senha',
                    ])
                    .then(valid => {
                        if (valid) {
                            this.loading = true;
                            let formData = new FormData();
                            formData.append('certificado_a1', this.certificado.certificado_a1);
                            formData.append('certificado_senha', this.certificado.certificado_senha);
                            this.$store
                                .dispatch('storeCertificate', formData)
                                .then(response => {
                                    this.loading = false;
                                    if (response.status === 'success') {
                                        this.$store.dispatch('getUserData');
                                        toastr({
                                            icon: response.status,
                                            title: response.message
                                        });
                                        $('#ModalCertificado').modal('toggle');
                                    }
                                });
                        }
                    });
            },
            previewCertificate(event) {
                this.certificado.certificado_a1 = event.target.files[0];
            },
            resetForm() {
                Object.assign(this.$data, this.$options.data());
                this.$validator.reset();
                const input = this.$refs.certificado
                input.type = 'text'
                input.type = 'file'
            }

        }
    };
</script>